import React from 'react'
// ##
import RolesTable from '../../modules/Role/components/RolesTable'

export default function RolePage() {
  return <RolesTable />
}
